import React, { useState, useEffect } from 'react';
import AttributeTable from '../../components/AttributeManagement/AttributeTable';
import AttributeForm from '../../components/AttributeManagement/AttributeForm';
import { getAttributes, createAttribute, updateAttribute, deleteAttribute } from '../../services/attributeService';


const AttributesManagement = () => {
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingAttribute, setEditingAttribute] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadAttributes();
  }, []);

  const loadAttributes = async () => {
    setLoading(true);
    try {
      const response = await getAttributes(searchTerm);
      setAttributes(response.data);
    } catch (error) {
      console.error('Error loading attributes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingAttribute(null);
    setShowForm(true);
  };

  const handleEdit = (attribute) => {
    setEditingAttribute(attribute);
    setShowForm(true);
  };

  const handleDelete = async (attribute) => {
    if (window.confirm(`آیا از حذف مشخصه "${attribute.name}" مطمئن هستید؟`)) {
      try {
        await deleteAttribute(attribute.id);
        loadAttributes();
      } catch (error) {
        alert('امکان حذف مشخصه استفاده شده وجود ندارد');
      }
    }
  };

  const handleSubmit = async (formData) => {
    try {
      if (editingAttribute) {
        await updateAttribute(editingAttribute.id, formData);
      } else {
        await createAttribute(formData);
      }
      setShowForm(false);
      loadAttributes();
    } catch (error) {
      console.error('Error saving attribute:', error);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    loadAttributes();
  };

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        {/* نوار ابزار */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            {/* جستجو */}
            <form onSubmit={handleSearchSubmit} className="flex-1 w-full sm:max-w-md">
              <div className="relative">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder="جستجو بر اساس عنوان مشخصه..."
                  className="w-full pr-10 pl-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <button
                  type="submit"
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </button>
              </div>
            </form>

            {/* دکمه افزودن */}
            <button
              onClick={handleCreate}
              className="bg-[#1E3A5F] text-[#FFC107] hover:bg-[#2B5388] hover:text-[#D19D00] px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              افزودن مشخصه جدید
            </button>
          </div>
        </div>

        {/* جدول مشخصه‌ها */}
        <AttributeTable
          attributes={attributes}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />

        {/* مودال فرم */}
        {showForm && (
          <AttributeForm
            attribute={editingAttribute}
            onSubmit={handleSubmit}
            onCancel={() => setShowForm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AttributesManagement;